import {FETCH_QUESTAO_APROVAR, FETCH_QUESTAO_PROFESSOR, FETCH_QUESTAO_JOGO, FETCH_EDITAR_QUESTAO} from '../actions/questaoActions';

const INITIAL_STATE = {
    allQuestaoAprovar: [],
    allQuestaoProfessor: [],
    allQuestaoJogo: [],
    editarquestao: {}
};

export default function (state = INITIAL_STATE, action) {

    switch (action.type) {

        case FETCH_QUESTAO_APROVAR:
            return {
                ...state,
                allQuestaoAprovar: action.payload.data
            }

        case FETCH_QUESTAO_JOGO:
            return {
                ...state,
                allQuestaoJogo: action.payload.data
            }

        case FETCH_EDITAR_QUESTAO:
            return {
                ...state,
                editarquestao: action.payload
            }

        case FETCH_QUESTAO_PROFESSOR:

            return {
                ...state,
                allQuestaoJogoProfessor: action.payload.data
            }

        default:
            return state;
    }

}




// WEBPACK FOOTER //
// ./src/reducers/reducer_questao.js